import { styled } from "@mui/material/styles";
import {
  IconButton,
  FormLabel as MuiFormLabel,
  FormLabelProps as MuiFormLabelProps,
  Popover,
} from "@mui/material";
import { FONT_COLORS } from "../../constants";
import InfoOutlineIcon from "@mui/icons-material/InfoOutline";
import { useState, MouseEvent, ReactNode } from "react";

type TFormLabelProps = MuiFormLabelProps & {
  renderTooltipContent?: () => ReactNode;
};

const StyledLabel = styled(MuiFormLabel)(() => ({
  marginBottom: 6,
  fontSize: 14,
  fontWeight: 500,
  lineHeight: "20px",
  color: FONT_COLORS.label,
}));

export const FormLabel = ({
  children,
  renderTooltipContent,
  ...restProps
}: TFormLabelProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <StyledLabel {...restProps}>
      {children}
      {renderTooltipContent && (
        <>
          <IconButton
            size="small"
            sx={{ ml: 0.3, mt: -0.2 }}
            onClick={handleClick}
          >
            <InfoOutlineIcon sx={{ fontSize: 16 }} />
          </IconButton>
          <Popover
            open={!!anchorEl}
            anchorEl={anchorEl}
            onClose={handleClose}
            elevation={2}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
          >
            {renderTooltipContent()}
          </Popover>
        </>
      )}
    </StyledLabel>
  );
};
